import styles from './downloadPdf.module.scss';
import SiteLink from '../../shared/sitelink';

const DownloadPdf = ({ data }) => {
  const { linkText, pdfUrl, anchorId } = data;

  return (
    <section id={anchorId}>
      <div className={styles.titleAndTextWrapper}>
        <SiteLink external={pdfUrl} className={styles.downloadAnchor}>
          {linkText}
        </SiteLink>
      </div>
    </section>
  );
};

export default DownloadPdf;
